import { Route } from "@angular/router";

export const VWijzerPaths = {};

export default [
  {
    path: "",
    loadComponent: () =>
      import("./pages/vwijzer/vwijzer.component").then((c) => c.VWijzerComponent),
    data: {
      breadcrumb: "V-Wijzer",
      title: "V-Wijzer",
    },
  },
] satisfies Route[];
